var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',{attrs:{"variant":_vm.variant,"target":"_blank","role":"button","href":_vm.shareUrl}},[_c('i',{staticClass:"fal fa-envelope fa-lg",class:_vm.customClass})])
}
var staticRenderFns = []

export { render, staticRenderFns }